export default "assets/images/icons/plane-672b5086.svg";